import Grid from "@material-ui/core/Grid";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { FormattedMessage } from "react-intl";
import { AppContext } from "../../../../../lib/appContext";
import { styles } from "./styles";

type ITipSliderContainer = WithStyles<typeof styles>;

const TipSliderContainer: React.FC<ITipSliderContainer> = ({ classes, children }) => {
  const { businessUnitConfig } = React.useContext(AppContext);
  const { name } = businessUnitConfig;
  return (
    <Grid
      container={true}
      justify={"center"}
      alignItems={"center"}
      classes={{ container: classes.container }}
    >
      <Grid item={true} xs={12}>
        <Typography variant={"h4"} component="h2" align={"center"} classes={{ h4: classes.title }}>
          <FormattedMessage id="tips.title" values={{ businessName: name }} />
        </Typography>
        <Grid item={true} xs={12} classes={{ item: classes.slideTrackContainer }}>
          {children}
        </Grid>
      </Grid>
    </Grid>
  );
};

export const TipsContainer = withStyles(styles)(TipSliderContainer);
